import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import { CreateService, TypeCreateServiceR } from '../../store/services/actions';
import { useDispatch } from 'react-redux';
import { ConfigurationsActions } from '../../store/configurations/actions';
import { ServiceForm } from '../../components/Services';

const CreateServicePage: React.FC = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    const query = new URLSearchParams(search);
    const siteId = query.get('site_id');
    if (siteId) {
      dispatch(ConfigurationsActions.setSiteId(Number(siteId)));
    }
  }, [dispatch, search]);

  const handleCreate = (data: TypeCreateServiceR['data'], callBack: (err?: string) => void) => {
    dispatch(
      CreateService.request({
        data,
        callBack: (success, dta) => {
          if (!success) {
            if (dta?.status === 409) callBack('Такий заголовок вже використовується');
            else callBack('Сталася помилка');
          } else {
            callBack();
            navigate(ROUTES.routeChange(`list/${dta?.id || ''}`));
          }
        },
      })
    );
  };

  return (
    <ServiceForm type='new' handleSubmit={handleCreate} handleCancel={() => navigate(ROUTES.routeChange('list'))} />
  );
};

export default CreateServicePage;
